"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverwolfXpFuelRewardNotificationMetadataToJSON = exports.OverwolfXpFuelRewardNotificationMetadataFromJSONTyped = exports.OverwolfXpFuelRewardNotificationMetadataFromJSON = void 0;
var _1 = require("./");
function OverwolfXpFuelRewardNotificationMetadataFromJSON(json) {
    return OverwolfXpFuelRewardNotificationMetadataFromJSONTyped(json, false);
}
exports.OverwolfXpFuelRewardNotificationMetadataFromJSON = OverwolfXpFuelRewardNotificationMetadataFromJSON;
function OverwolfXpFuelRewardNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rewardType': (0, _1.RewardTypeFromJSON)(json['rewardType']),
        'amount': json['amount'],
        'notificationType': (0, _1.NotificationTypeFromJSON)(json['notificationType']),
    };
}
exports.OverwolfXpFuelRewardNotificationMetadataFromJSONTyped = OverwolfXpFuelRewardNotificationMetadataFromJSONTyped;
function OverwolfXpFuelRewardNotificationMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rewardType': (0, _1.RewardTypeToJSON)(value.rewardType),
        'amount': value.amount,
        'notificationType': (0, _1.NotificationTypeToJSON)(value.notificationType),
    };
}
exports.OverwolfXpFuelRewardNotificationMetadataToJSON = OverwolfXpFuelRewardNotificationMetadataToJSON;
